<script setup>
/**
 * One 9:16 clip thumbnail with its title — the "More Clips" grid in the feed sidebar and
 * the scene page's "Clips made from this scene" row. Takes the `{id, slug, title, thumbnail}`
 * shape VerticalClipsFeedService::moreClips() and ::sceneRow() both return.
 *
 * A plain <a> on purpose: a full reload re-runs the feed controller so the clip arrives as
 * the first slide with its own server-rendered meta.
 */
defineProps({
    clip: { type: Object, required: true },
    href: { type: String, required: true },
})
</script>

<template>
    <a
        :href="href"
        class="group relative block bg-zinc-900 rounded-lg overflow-hidden hover:ring-2 hover:ring-white/20 transition-all text-left"
    >
        <div class="relative w-full aspect-[9/16] bg-zinc-800 overflow-hidden">
            <img
                v-if="clip.thumbnail"
                :src="clip.thumbnail"
                :alt="clip.title"
                class="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
            />
        </div>

        <div class="p-2">
            <h4 class="text-white text-xs font-semibold line-clamp-2 leading-tight">
                {{ clip.title }}
            </h4>
        </div>
    </a>
</template>
